import apiClient from './axiosConfig'; // Import apiClient
import { API_ENDPOINTS } from '../constants';

// Removed individual caching logic, now handled by axiosConfig interceptors

const fetchHeaderFooter = async () => {
  try {
    const response = await apiClient.get(API_ENDPOINTS.HEADER_FOOTERS); // Use apiClient.get
    return response.data; // Axios wraps response in .data
  } catch (error) {
    console.error('Error fetching Header/Footer data:', error);
    throw error;
  }
};

export { fetchHeaderFooter };